module.exports = __webpack_public_path__ + "media/images/category/dummy/shoes05-44fd846dfc3ce668c20f4c3807830af6.jpg";